import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const slideIn = keyframes`from{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}`
const slideOut = keyframes`from{transform:translateY(0);opacity:1}to{transform:translateY(-100%);opacity:0}`

const Container = styled.div`
  position: fixed; top: 20px; left: 50%; transform: translateX(-50%);
  background: #2D3748; color: white; padding: 12px 24px; border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,.1); z-index: 9999;
  animation: ${p => p.isExiting ? slideOut : slideIn} .3s ease-in-out forwards;
  display: flex; align-items: center; gap: 12px;
`
const Icon = styled.span`color:${p => p.type === 'success' ? '#68D391' : p.type === 'error' ? '#FC8181' : '#63B3ED'};font-size:20px`

export const Notification = ({ message, type = 'info', duration = 3000, onClose }) => {
  const [isExiting, setIsExiting] = React.useState(false)
  useEffect(() => {
    const t1 = setTimeout(() => setIsExiting(true), duration - 300)
    const t2 = setTimeout(onClose, duration)
    return () => { clearTimeout(t1); clearTimeout(t2) }
  }, [duration, onClose])
  const icon = type === 'success' ? '✓' : type === 'error' ? '!' : 'i'
  return (
    <Container isExiting={isExiting}>
      <Icon type={type}>{icon}</Icon>
      <span style={{ fontSize: 14 }}>{message}</span>
    </Container>
  )
}
